import axios from "axios";
import { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import urls from "../urls";

export default class StoreItemsSelect extends Component {
  state = {
    options: [],
  };
  componentDidMount() {
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));
    axios
      .get(urls.getStoreItems, {
        params: {
          faculty_id,
        },
      })
      .then((res) => {
        console.log(res.data.results);
        const options = res.data.results.map((obj) => ({
          label: obj.item_name,
          value: obj.uuid,
        }));
        this.setState({ options });
      });
  }
  noOptionsMessage = () => `لا توجد نتائج `;
  handleSelectChange = (obj) => {
    if (this.props.onItemSelect) {
      console.log(obj);
      this.props.onItemSelect(obj);
    }
  };
  render() {
    const { options } = this.state;
    const placeholder = "إختر اسم السلعة ";
    return (
      <div>
        <Select
          options={options}
          isSearchable={true}
          isRtl={true}
          noOptionsMessage={this.noOptionsMessage}
          placeholder={placeholder}
          onChange={this.handleSelectChange}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
      </div>
    );
  }
}

// const mapDispatchToProps = {};
// const mapStateToProps = (state) => ({});
// export default connect(mapStateToProps, mapDispatchToProps)(StoreItemsSelect);
